import { render, staticRenderFns } from "./HighEndBouns.vue?vue&type=template&id=5f3972aa&scoped=true&"
import script from "./HighEndBouns.vue?vue&type=script&lang=js&"
export * from "./HighEndBouns.vue?vue&type=script&lang=js&"
import style0 from "./HighEndBouns.vue?vue&type=style&index=0&id=5f3972aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3972aa",
  null
  
)

export default component.exports